const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const api = "banks";

const createBank = ({
	name,
	accountNumber,
	accountType,
	hidden,
	code,
	paymentMethod,
	alias,
	addDescription,
	addGeneratedAdvance,
}) => {
	return new Promise((resolve, reject) => {
		postRequest(
			api,
			{
				name,
				accountNumber,
				accountType,
				hidden,
				code,
				paymentMethod,
				alias,
				addDescription,
				addGeneratedAdvance,
			},
			resolve,
			reject,
			true
		);
	});
};

const updateBank = ({
	_id,
	name,
	accountNumber,
	accountType,
	hidden,
	code,
	paymentMethod,
	alias,
	addDescription,
	addGeneratedAdvance,
}) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${_id}`,
			{
				name,
				accountNumber,
				accountType,
				hidden,
				code,
				paymentMethod,
				alias,
				addDescription,
				addGeneratedAdvance,
			},
			resolve,
			reject,
			true
		);
	});
};

const deleteBank = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getBankDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getBanks = (hidden = false) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}${hidden ? "?hidden=true" : ""}`, resolve, reject, true);
	});
};

module.exports = {
	createBank,
	deleteBank,
	getBankDetails,
	getBanks,
	updateBank,
};
